import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Container, CssBaseline } from '@mui/material';
import SEO from '../../components/SEO';
import { Navbar } from '../Navbar/Navbar';
import DocumentDetail from './Documentation/DocumentDetail';
import { Footer } from '../Footer';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const TopMargin = styled.div`
  margin-top: 62px;  // Adjust this value based on your design needs
  text-align: justify;
`;

export default function DocumentDetailPage() {
  return (
    <>
      <PageWrapper>
        <SEO
          title="WatchNod Documentation | Server Monitoring Setup & Guide"
          description="Explore WatchNod documentation to learn server monitoring setup, performance tracking, uptime monitoring, and alerts for reliable infrastructure management."
          url="/document"
        />
        <Container maxWidth="xl">
          <Navbar />
          <TopMargin>
            <CssBaseline />
            <DocumentDetail />
          </TopMargin>
        </Container>
        <Footer />
      </PageWrapper >
    </>
  );
}
